import React, { useState } from "react";
import Classes from "./RecordTable.module.css";
import useScreenWidth from "../../../../../../../Hooks/useScreenWidth";
import SkeletonLoading from "../../../../../../GlobalComponents/SkeletonLoading/SkeletonLoading";
import { Pagination, Stack } from "@mui/material";
import TableRow from "./TableRow";
import { useNavigate } from "react-router-dom";

export default function RecordTable({ bookings, loading }) {
  const navigateTo = useNavigate();
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= 480;

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(bookings?.length / itemsPerPage);
  const currentItems = bookings?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, bookings?.length);
  const totalItems = bookings?.length;

  function handlePageChange(e, pageNum) {
    setCurrentPage(pageNum);
  }

  return (
    <div className={Classes.hero}>
      <div className={Classes.table}>
        <div className={Classes.tableWrapper}>
          <div className={Classes.tableHeader}>
            <div className={`${Classes.headerItem} ${Classes.header1}`}>
              <h5>Name</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header2}`}>
              <h5>Type</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header3}`}>
              <h5>Meeting Starts</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header4}`}>
              <h5>Status</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header5}`}>
              <h5>Meeting Link</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header6}`}>
              <h5>Profile</h5>
            </div>
            <div className={`${Classes.headerItem} ${Classes.header7}`}>
              <h5>Rating</h5>
            </div>
          </div>

          <div className={Classes.tableBody}>
            {loading ? (
              <SkeletonLoading
                length={itemsPerPage}
                height={isMobile ? "3.5rem" : "2.8rem"}
                width="100%"
                br="6px"
                padding="0"
              />
            ) : currentItems && currentItems.length > 0 ? (
              currentItems.map((cust, idx) => (
                <TableRow key={cust._id} value={cust} index={idx} />
              ))
            ) : (
              <h5 className='placeholderText' style={{ margin: '1rem 1.2rem' }} >No upcoming meetings...</h5>
            )}
          </div>
          {currentItems && currentItems?.length > 0 ?
            <div className={Classes.pagFooter}>
              <h5 style={{ height: "1.2rem" }}>
                {loading ? (
                  <SkeletonLoading height="1.2rem" width="10rem" br="4px" padding="0" />
                ) : (
                  `Showing ${startItem} to ${endItem} of ${totalItems} results`
                )}
              </h5>
              <Stack spacing={2} className={Classes.pagination}>
                {loading ? (
                  <SkeletonLoading height="1.2rem" width="5rem" br="4px" padding="0" />
                ) : (
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    shape="rounded"
                  />
                )}
              </Stack>
            </div>
            : null}
        </div>
      </div>
    </div>
  );
}